import { useState } from 'react';
import { useRouter } from 'next/router';
// @mui
import {
  Stack,
  Card,
  Typography,
  Button,
} from '@mui/material';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import Iconify from '../../../components/Iconify';
import DIOText from '../../../components/DIOText';
// routes
import { PATH_SETTINGS } from '../../../routes/paths';
// dialogs
import JobChangeInterestDialog from './JobChangeInterestDialog';

// ----------------------------------------------------------------------
export default function RewardCards() {
  const router = useRouter();
  const [isJobChangeDialogOpen, setIsJobChangeDialogOpen] = useState(false);

  const handleOpenJobChangeDialog = () => {
    setIsJobChangeDialogOpen(true);
  };

  const handleCloseJobChangeDialog = () => {
    setIsJobChangeDialogOpen(false);
  };

  return (
    <Stack spacing={2}>
      {/* 1. ALLOW TO OPEN */}
      <Card
        sx={{
          p: { xs: 2, sm : 2.5 },
          backgroundColor: 'grey.100',
          borderRadius: 2,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: 'grey.300',
            transition: 'background-color 0.3s',
            cursor: 'pointer',
          },
        }}
        onClick={() => {
          router.push({pathname: PATH_SETTINGS.root, query: {tab: 'matching'}});
        }}
      >
        <Stack spacing={.5}>
          <Stack direction="row" alignItems="flex-start" spacing={1}>
            <SvgIconStyle src={`/icons/icon-lightning-mono.svg`} sx={{ width: 22, height: 22 }} />
            <Stack spacing={.5}>
              <Typography variant="subtitle2">빠른 매칭을 원하시나요?</Typography>
              <Typography variant="body2">기업이 먼저 내 프로필을 보고 제안할 수 있도록 프로필을 공개하기</Typography>
            </Stack>
          </Stack>
          <Button 
            variant="text" 
            color="inherit" 
            size="small" 
            sx={{ alignSelf: 'flex-end', '&:hover': { backgroundColor: 'transparent' } }}
            endIcon={<Iconify icon="eva:arrow-ios-forward-fill" />}
          >
            공개 설정하기
          </Button>
        </Stack>
      </Card>
      {/* 2. INTEREST */}
      <Card
        sx={{
          p: { xs: 2, sm : 2.5 },
          backgroundColor: (theme) => `${theme.palette.warning.main}14`,
          borderRadius: 2,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: (theme) => `${theme.palette.warning.main}3D`,
            transition: 'background-color 0.3s',
            cursor: 'pointer',
          },
        }}
        onClick={handleOpenJobChangeDialog}
      >
        <Stack spacing={.5}>
          <Stack direction="row" alignItems="flex-start" spacing={1}>
            <SvgIconStyle src={`/icons/ic-job.svg`} sx={{ width: 22, height: 22 }} />
            <Stack spacing={.5}>
              <Typography variant="subtitle2">이직 기회도 함께 알아볼까요?</Typography>
              <Typography variant="body2">매칭 외 정규직 기회도 알아보기</Typography>
            </Stack>
          </Stack>
          <Button 
            variant="text" 
            color="inherit" 
            size="small" 
            sx={{ alignSelf: 'flex-end', '&:hover': { backgroundColor: 'transparent' } }}
            endIcon={<Iconify icon="eva:arrow-ios-forward-fill" />}
          >
            더 알아보기
          </Button>
        </Stack>
      </Card>

      {/* Job Change Interest Dialog */}
      <JobChangeInterestDialog 
        isOpen={isJobChangeDialogOpen}
        closeDialog={handleCloseJobChangeDialog}
      />
    </Stack>
  );
};